import { FIELD_TYPES } from "constants/template-field-type";
import RegularButtonFieldsConfig from "segments/desktop/core-components/button/regular-button/fields-config";
const { buttonSize, color, outline } = RegularButtonFieldsConfig;
export default {
    contactSalesTranslateKey: {
        type: FIELD_TYPES.COMBO,
        label: "Text override",
        options: [
            {
                value: "header.contactSales",
                text: "Contact sales"
            },
            {
                value: "header.requestADemo",
                text: "Request a demo"
            },
            {
                value: "pricingPage.get_quote",
                text: "Get a quote"
            }
        ]
    },
    scrollToElementId: {
        type: FIELD_TYPES.TEXT,
        label: "Segment ID to scroll to",
        labelDescription: "If provided, the button will scroll to the element with this ID when clicked."
    },
    buttonSize,
    color,
    outline
};
